export class ProductCategoryModel {
    public code: string;
}